import React from 'react';

export default function List({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.3 10.2" preserveAspectRatio="xMidYMid meet"><path d="M9.6 1.5H.8c-.5 0-.8-.3-.8-.7S.3 0 .8 0h8.8c.4 0 .8.3.8.8s-.4.7-.8.7zM9.6 5.9H.8c-.5 0-.8-.4-.8-.8s.3-.8.8-.8h8.8c.4 0 .8.3.8.8s-.4.8-.8.8zM9.6 10.2H.8c-.5 0-.8-.3-.8-.7s.3-.8.8-.8h8.8c.4 0 .8.3.8.8s-.4.7-.8.7z"/></svg>
	);
}
